"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageFileToCuttedResizedSquareBlob = exports.imageFileToResizedBlob = exports.blobToFile = exports.blobToDataURL = exports.dataURLtoBlob = exports.base64toBlob = void 0;
const gs = require("..");
function base64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}
exports.base64toBlob = base64toBlob;
/**
    * @param {string} dataurl
    * @returns {Blob}
*/
function dataURLtoBlob(dataurl) {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}
exports.dataURLtoBlob = dataURLtoBlob;
/**
    * @param {Blob} blob
    * @returns {Promise<String>}
    */
function blobToDataURL(blob) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const a = new FileReader();
            a.onload = (e) => { resolve(e.target.result); };
            try {
                a.readAsDataURL(blob);
            }
            catch (e) {
                reject(e);
            }
        });
    });
}
exports.blobToDataURL = blobToDataURL;
/**
    * @param {Blob} blob
    * @param {string} filename
    * @returns {File}
    */
function blobToFile(blob, filename) {
    let file = new File([blob], filename, { type: blob.type, lastModified: Date.now() });
    return file;
}
exports.blobToFile = blobToFile;
/**
* Load image file, then resize it and return blob
*/
function imageFileToResizedBlob(file, maxSize) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            if (!file.type.match(/image.*/))
                reject("not image");
            const reader = new FileReader();
            reader.onload = function (readerEvent) {
                const image = new Image();
                image.onload = function (imageEvent) {
                    // Resize the image
                    let canvas = document.createElement('canvas'), width = image.width, height = image.height;
                    if (width > height) {
                        if (width > maxSize) {
                            height *= maxSize / width;
                            width = maxSize;
                        }
                    }
                    else {
                        if (height > maxSize) {
                            width *= maxSize / height;
                            height = maxSize;
                        }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                    let dataUrl = canvas.toDataURL('image/jpeg');
                    let resizedImage = gs.blob.dataURLtoBlob(dataUrl);
                    resolve(resizedImage);
                };
                image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
        });
    });
}
exports.imageFileToResizedBlob = imageFileToResizedBlob;
function imageFileToCuttedResizedSquareBlob(file, sideSize) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            if (!file.type.match(/image.*/))
                reject("not image");
            const reader = new FileReader();
            reader.onload = function (readerEvent) {
                const image = new Image();
                image.onload = function (imageEvent) {
                    // Resize the image
                    let canvas = document.createElement('canvas'), width = image.width, height = image.height, deltaX = 0, deltaY = 0;
                    if (width > height) {
                        height = sideSize;
                        width = sideSize * image.width / image.height;
                        deltaX = -parseInt((width - sideSize) / 2 + "");
                    }
                    else {
                        width = sideSize;
                        height = sideSize * image.height / image.width;
                        deltaY = -parseInt((height - sideSize) / 2 + "");
                    }
                    canvas.width = sideSize;
                    canvas.height = sideSize;
                    canvas.getContext('2d').drawImage(image, deltaX, deltaY, width, height);
                    let dataUrl = canvas.toDataURL('image/jpeg');
                    let resizedImage = gs.blob.dataURLtoBlob(dataUrl);
                    resolve(resizedImage);
                };
                image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
        });
    });
}
exports.imageFileToCuttedResizedSquareBlob = imageFileToCuttedResizedSquareBlob;
//# sourceMappingURL=blob.js.map